<div class="modal-header d-flex flex-row align-items-center justify-content-between">
  <div class="d-flex flex-row align-items-center p-2">
    <div class="chip-icon primary small">
      <div class="inner"><i class="ti ti-mail"></i></div>
    </div>
    <span class="title ms-2">Nous contacter</span>
  </div>
  <button class="button m icon transparent" (click)="close()"><i class="ti ti-x"></i></button>
</div>
<div class="modal-content">
  <h2>Nous rendre visite</h2>
  <p class="mt-4" [innerHTML]="config?.address?.join('<br />') || ''"></p>
  <p [innerHTML]="config?.contactHours || ''"></p>
  <span class="phone mt-4">{{ config?.phone || '' }}</span>
  <span class="mail">{{ config?.email || '' }}</span>
  <h2 class="mt-5">Nous envoyer un mail</h2>
  <form [formGroup]="contactForm" class="d-flex flex-column gap-3 w-100 mt-4" (ngSubmit)="contactMutuelle()"
    id="contact-form">
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label class="form-label required">Motif de votre demande</label>
      <input class="form-control" type="text" formControlName="subject"
        [class.is-invalid]="contactForm.get('subject').invalid && contactForm.get('subject').touched">
    </div>
    <div class="d-flex flex-column gap-2 form-group w-100">
      <label class="form-label required">Votre demande</label>
      <textarea formControlName="message"
        [class.is-invalid]="contactForm.get('message').invalid && contactForm.get('message').touched"></textarea>
    </div>
    <ng-container *ngIf="allowAttachments">
      <div class="d-flex flex-column gap-2 form-group w-100">
        <label class="form-label">Pièces jointes</label>
        <div class="d-flex flex-column gap-2">
          <div *ngFor="let file of files" class="uploaded-file">
            <span>{{ file.name }}</span>
            <button class="button m icon transparent" type="button" (click)="removeFile(file)">
              <i class="ti ti-trash"></i>
            </button>
          </div>
        </div>
        <app-file-uploader (onFilesAdded)="addFile($event)"></app-file-uploader>
      </div>
    </ng-container>
  </form>
</div>
<div class="modal-footer d-flex flex-row align-items-center justify-content-end gap-2">
  <button class="button m" (click)="close()" type="button">Fermer</button>
  <button class="button m primary" type="submit" form="contact-form">Envoyer la demande</button>
</div>